<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-02 09:19:52
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-02-09 15:03:05
 * @FilePath: \Nivara\src\views\wallet\walletView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="wallet-container">
    <div class="wallet-content">
      <div class="wallet-total-type">
        <div class="wallet-total-box">
          <div>total</div>
          <div class="total-amount">
            {{ withdrawObj.availableBalance }} Points
          </div>
          <span
            >≈ {{ withdrawObj.availableBalance }}
            {{ withdrawObj.currency_name }}</span
          >
        </div>
        <div class="wallet-type-box">
          <div class="wallet-type-title">My Wallet</div>
          <div class="wallet-item-box">
            <div
              class="wallet-item"
              :class="walletType == index ? 'active' : ''"
              @click="
                walletType = index;
                withdrawBankId = 0;
              "
              v-for="(item, index) in walletTypeListData"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="wallet-type-content">
        <WithdrawaRecord v-if="walletType == 0"></WithdrawaRecord>
        <BindBank v-if="walletType == 1"></BindBank>
        <Withdraw
          :bankId="withdrawBankId"
          @withdrawSuccess="withdrawSuccess"
          @toSettingWithdrawPassword="toSettingWithdrawPassword"
          v-if="walletType == 2"
        ></Withdraw>
        <WithdrawaPassword v-if="walletType == 3"></WithdrawaPassword>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import WithdrawaRecord from "./components/withdrawaRecordView.vue";
import BindBank from "./components/bindBankView.vue";
import Withdraw from "./components/withdrawView.vue";
import WithdrawaPassword from "./components/withdrawaPasswordView.vue";
import bus from "../../utils/eventBus";
import { getUserWithdrawInfoApi } from "../../api/index";

export default defineComponent({
  name: "Wallet",
  components: { WithdrawaRecord, BindBank, Withdraw, WithdrawaPassword },
  setup() {
    onMounted(() => {
      getUserWithdrawInfo();
      bus.emit("changeTitle", "Wallet");
      bus.on("useCurrentBindBankToWithdraw", (bankId) => {
        console.log(bankId);
        withdrawBankId.value = bankId;
        walletType.value = 2;
      });
    });
    const walletType = ref(0);
    const withdrawBankId = ref(0);
    const state = reactive({
      walletTypeListData: [
        "Withdrawal record",
        "Bind bank",
        "Withdraw",
        "Withdrawal password",
      ],
      withdrawObj: {
        minimum_amount: 0,
        availableBalance: 0,
      },
    });
    const withdrawSuccess = () => {
      getUserWithdrawInfo();
    };
    const toSettingWithdrawPassword = () => {
      walletType.value = 3;
    };
    // 获取提现信息
    const getUserWithdrawInfo = () => {
      getUserWithdrawInfoApi({ token: localStorage.getItem("token") }).then(
        (res) => {
          console.log("getUserWithdrawInfoApi：", res);
          if (res.data.success && res.data.data) {
            state.withdrawObj = res.data.data;
            state.withdrawObj.availableBalance = res.data.data.cashable_amount;
            state.withdrawObj.minimum_amount = res.data.data.minimum_amount;
          }
        }
      );
    };
    return {
      walletType,
      withdrawBankId,
      withdrawSuccess,
      toSettingWithdrawPassword,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.wallet-container {
  min-height: 800px;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  background-color: #f7f7f7;
  .wallet-content {
    display: flex;
    .wallet-total-type {
      display: flex;
      flex-direction: column;
      width: 257px;
      min-width: 257px;
      .wallet-total-box {
        padding: 20px;
        border-radius: 12px 12px 12px 12px;
        background-color: #ffffff;
        text-align: left;
        font-size: 16px;
        .total-amount {
          margin: 5px 0;
          font-size: 22px;
          font-weight: bold;
        }
      }
      .wallet-type-box {
        flex: 1;
        margin-top: 20px;
        padding: 20px;
        border-radius: 12px 12px 12px 12px;
        background-color: #ffffff;
        .wallet-type-title {
          padding-bottom: 20px;
          text-align: left;
          font-size: 16px;
          color: #000000;
          font-weight: bold;
          border-bottom: 1px solid #dfdfdf;
        }
        .wallet-item-box {
          .wallet-item {
            margin-top: 10px;
            padding: 13px 0;
            font-size: 14px;
            background-color: #efefef;
            color: #03004d;
            border-radius: 12px;
            cursor: pointer;
            &.active {
              background-color: #03004d;
              color: #ffffff;
            }
          }
        }
      }
    }
    .wallet-type-content {
      min-width: 1018px;
      padding: 20px;
      margin-left: 10px;
      border-radius: 12px 12px 12px 12px;
      background-color: #ffffff;
    }
  }
}
</style>
